var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isVisible)?_c('div',{class:['note-block', 'mb-2']},[_c('h3',{class:['mb-2', { 'd-none': !_vm.showHeadline }]},[_vm._v(_vm._s(_vm.blockHeadline))]),_c('div',[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }